import { TranslateService } from '@ngx-translate/core';

/**
 * Thin memoization wrapper around TranslateService.instant().
 * Calling translate.instant() for the same key thousands of times during a
 * search hot path is wasteful — this caches per (lang, key).
 *
 * Engine resets the cache on language change (see IntelligentSearchService).
 */
export class TranslationCache {
  private cache = new Map<string, string>();
  private currentLang = '';

  constructor(private translate: TranslateService) {
    this.currentLang = translate.currentLang || translate.getDefaultLang() || 'de';
  }

  resolve(key: string | undefined): string {
    if (!key) return '';
    const lang = this.translate.currentLang || this.currentLang;
    const cacheKey = `${lang}::${key}`;
    const hit = this.cache.get(cacheKey);
    if (hit !== undefined) return hit;
    const value = this.translate.instant(key);
    // If translation missing, ngx-translate returns the key — keep that as a fallback
    this.cache.set(cacheKey, value ?? key);
    return value ?? key;
  }

  invalidate(): void {
    this.cache.clear();
    this.currentLang = this.translate.currentLang || this.translate.getDefaultLang() || 'de';
  }
}
